import {
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TableRow
} from '@material-ui/core';
import Axios from "axios";
import React, { useEffect, useState } from 'react';
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import FileListRow from './_partials/FileListRow';
import FileUpload from './_partials/FileUpload';

function Upload(props){
    const [open, setOpen]               = useState(false);
    const mobile                        = window.matchMedia("(max-width: 768px)");
    const [isMobile, setIsMobile]       = useState(mobile.matches);
    const [files, setFiles]             = useState([]);
    const {order}                       = props;
    const {client_case_id}              = props;

    const handleClose = () => {
        setOpen(false);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };


    const getFiles = async () => {
        const formData = {
            case_id:client_case_id,
            source:'court-order',
            source_id:order.id,
        };
        await Axios.post(`api/file/getFiles`, formData)
        .then((res)=>{
            setFiles(res.data.data);
        });
    };

    useEffect(()=>{
        getFiles();
        const windowHandler =()=> {
            setIsMobile(mobile.matches)
        };
        mobile.addEventListener("change", windowHandler);
        return () => {
            mobile.removeEventListener("change", windowHandler);
        }
    }, []);

    return(
        <>
        <span className={`svg-icon svg-icon-md ${files.length !== 0 ? 'svg-icon-success' : 'svg-icon-primary'}`}>
        <SVG
          onClick={handleClickOpen}
          src={toAbsoluteUrl("/media/svg/icons/Files/File.svg")}
        ></SVG>
        </span>
        <Dialog
            fullWidth={true}
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle className="mt-2" id="alert-dialog-title">{"Court Order Files"}</DialogTitle>
            <Divider className='mtb-10'/>
            <DialogContent>
            <FileUpload order={order} setFiles={setFiles}/>
                <div className="login-form login-signin" id="kt_login_signin_form">
                    <TableContainer component={Paper} style={{minHeight: '500px'}}>
                        <Table aria-label="collapsible table">
                        <TableHead>
                            <TableRow>
                            {isMobile ? <TableCell></TableCell> : null}
                            <TableCell className="font-weight-bold text-uppercase text-muted fs-1">NAME</TableCell>
                            <TableCell align="left" className="font-weight-bold text-uppercase text-muted fs-1">SIZE</TableCell>
                            <TableCell align="left" className="font-weight-bold text-uppercase text-muted fs-1">TYPE</TableCell>
                            <TableCell align="left" className="font-weight-bold text-uppercase text-muted fs-1">ACTION</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {files.map((row, index) => (
                                <FileListRow key={row.section_id} row={row} setFiles={setFiles}/>
                            ))}
                        </TableBody>
                        <TableFooter>
                            {/* <Pagination 
                            className="mt-5"
                            count={paginate} 
                            color={'secondary'} 
                            onChange={(event,page)=> {
                                paginationEvent(page)
                            }} 
                            variant="text" shape="rounded" 
                            /> */}
                        </TableFooter>
                        </Table>
                    </TableContainer>
                </div>
            </DialogContent>
        </Dialog>
        </>
    )
}
export default Upload